import React from "react";
import "./AccessDenied.scss"; // Import the SCSS file
import avatarImage from "../Images/output.jpg"; // Update with the actual path

const AccessDenied = () => {
  return (
    <div className="access-denied">
      <img
        src={avatarImage}
        alt="Access Denied Avatar"
        className="bouncing-avatar"
      />
      <h1>Access Denied</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default AccessDenied;
